import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_THUDELETE } from "../actions/DanhSachThuDelete/actionTypes";
import {
  getListThuDeleteSuccess,
  getListThuDeleteFailure,
} from "../actions/DanhSachThuDelete";
import DanhSachThuDeleteApi from "../service/danhSachThuDeleteApi";

function* getListThuDelete(action) {
  try {
    const response = yield call(
      DanhSachThuDeleteApi.GetDanhSachThuDelete,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getListThuDeleteSuccess(response.data));
    } else {
      yield put(getListThuDeleteFailure());
    }
  } catch (error) {
    yield put(getListThuDeleteFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_THUDELETE, getListThuDelete);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
